export interface Attachment {
  id: string
  name: string
  file: File | string
}

export interface CreateThreadForm {
  title: string
  sticky: boolean
  user: string
  users: string[]
  leaderGroups: string[]
  sendSms: boolean
  sendEmail: boolean
}

export type RecipientItem = {
  text: string
  isGroup?: boolean
  isMore?: boolean
}


export const ForumTabKey = {
  GENERAL: 'general',
  DIRECT: 'direct',
}
